export default function HeadLine({ headline, text }) {
	const HeadingTag = headline.type;

	const containerClass = `container my-5${text ? " headline-text" : ""}`;

	return (
		<section className={containerClass}>
			<div className="inner">
				<div className="row align-items-center">
					<div className={`col-12 text-${headline.style}`}>
						<HeadingTag dangerouslySetInnerHTML={{ __html: headline.text }} />
						{ text && <p>{ text }</p> }
					</div>
				</div>
			</div>
		</section>
	);
}
